// Module
var code = "<dt class=\"ndd-ng-data-group__title\">{{ dataTitle }}</dt> <p class=\"ndd-ng-data-group__description\" *ngIf=\"dataDescription\">{{ dataDescription }}</p> <dl class=\"ndd-ng-data-group__definitions\"> <ng-content></ng-content> </dl> ";
// Exports
module.exports = code;